import { cn } from "@/lib/utils";

type TooltipButtonProps = {
  onClick: () => void;
  label: string;
  icon: string;
  bgClass: string;
  textClass: string;
  hoverBgClass: string;
  hoverTextClass: string;
};

export default function TooltipButton({
  onClick,
  label,
  icon,
  bgClass,
  textClass,
  hoverBgClass,
  hoverTextClass,
}: TooltipButtonProps) {
  return (
    <div className="group/tip relative flex-1">
      <button
        type="button"
        onClick={onClick}
        aria-label={label}
        className={cn(
          "flex w-full cursor-pointer items-center justify-center rounded-lg px-2 py-2.5 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          bgClass,
          hoverBgClass,
          textClass,
          hoverTextClass
        )}
      >
        <i className={cn(icon, "text-base")} />
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute -top-8 left-1/2 z-50 -translate-x-1/2 whitespace-nowrap rounded-md bg-foreground px-2 py-1 text-xs text-background opacity-0 transition-opacity group-hover/tip:opacity-100 group-focus-within/tip:opacity-100"
      >
        {label}
      </span>
    </div>
  );
}
